import { Icon } from "@sellar-io/components";
import { NavigationOverlay } from "./NavigationOverlay";
import { useNavigationOverlay } from "./NavigationOverlayContext.shared";
import { MessagesNavigationContent } from "./MessagesNavigationContent";

export const MessagesNavigationOverlay = () => {
  const { closeOverlay } = useNavigationOverlay();
  return (
    <NavigationOverlay
      id="messages"
      title="Messages"
      trigger={(props) => (
        <button
          {...props}
          type="button"
          aria-label="Messages"
          className="relative inline-flex size-8 shrink-0 items-center justify-center rounded-full p-0 text-zinc-800 hover:text-[#a34fd2] focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-purple-600 aria-expanded:text-[#8c23c7]"
        >
          <Icon icon="MESSAGE_OUTLINE" size="20px" />
        </button>
      )}
    >
      <MessagesNavigationContent onClose={() => closeOverlay("messages")} />
    </NavigationOverlay>
  );
};
